// appshell-auto-nav.ts · Navegación propia del área de miembros Robotea Auto.
// ---------------------------------------------------------------------------
// El AutoShell NO reutiliza la nav del campus del curso: Auto es un producto
// premium aparte ("gestión", no "formación") y su menú refleja ese mundo.
//
// Solo '/auto' tiene página en este spec (F-CAMPUS-AUTO-ACCESO). El resto de
// ítems (cuenta/robots/informes/…) se implementa en el spec del Panel Auto;
// mientras tanto AutoShell los muestra como "Próximamente" sin ruta muerta.
//
// Owner: Carlos Beltrán · 2026-07-08 · F-CAMPUS-AUTO-ACCESS-001

import {
  Cpu,
  FileText,
  LayoutDashboard,
  LifeBuoy,
  User,
  Users,
  Wallet,
} from 'lucide-react';

export const AUTO_NAV = [
  { to: '/auto',           label: 'Resumen',    icon: LayoutDashboard },
  { to: '/auto/cuenta',    label: 'Mi cuenta',  icon: Wallet },
  { to: '/auto/robots',    label: 'Mis robots', icon: Cpu },
  { to: '/auto/informes',  label: 'Informes',   icon: FileText },
  { to: '/auto/soporte',   label: 'Soporte',    icon: LifeBuoy },
  { to: '/auto/referidos', label: 'Referidos',  icon: Users },
  { to: '/auto/perfil',    label: 'Perfil',     icon: User },
] as const;

/** Rutas del AUTO_NAV que YA tienen página registrada en App.tsx.
 *  Lo demás se pinta como "Próximamente" (sin enlace muerto → sin 404). */
export const AUTO_NAV_IMPLEMENTED = new Set<string>(['/auto']);
